import { useState, useEffect, useRef } from 'react'

// exclusive=true (default): classic single-open accordion (matches original TrekFAQ behavior).
// exclusive=false: multiple items can be open; pair with `openAll` for an expand/collapse-all toggle.
export default function Accordion({
  items,
  defaultOpenIndex = 0,
  exclusive = true,
  openAll = false,
  renderQuestion = item => item.q,
  renderAnswer = item => item.a,
}) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex)
  const [openIndexes, setOpenIndexes] = useState(
    () => new Set(defaultOpenIndex == null ? [] : [defaultOpenIndex])
  )
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (!exclusive && items) {
      setOpenIndexes(openAll ? new Set(items.map((_, i) => i)) : new Set())
    }
  }, [openAll, exclusive, items])

  const isOpen = i => (exclusive ? openIndex === i : openIndexes.has(i))
  const toggle = i => {
    if (exclusive) {
      setOpenIndex(prev => (prev === i ? null : i))
    } else {
      setOpenIndexes(prev => {
        const next = new Set(prev)
        next.has(i) ? next.delete(i) : next.add(i)
        return next
      })
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {items && items.map((item, i) => {
        const open = isOpen(i)
        return (
          <div key={i} style={{ borderBottom: '1px solid var(--stone-mid)', paddingBottom: '12px' }}>
            <button
              onClick={() => toggle(i)}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '16px 0',
                textAlign: 'left',
                gap: '24px',
              }}
            >
              <div style={{
                fontSize: '15px',
                fontWeight: 600,
                color: open ? 'var(--green)' : 'var(--ink)',
                transition: 'color 0.2s',
              }}>
                {renderQuestion(item)}
              </div>
              <div style={{
                fontSize: '22px',
                color: 'var(--green-mid)',
                transform: open ? 'rotate(45deg)' : 'none',
                transition: 'transform 0.2s',
                lineHeight: 1,
              }}>
                +
              </div>
            </button>
            {open && (
              // A div, not a <p>: renderAnswer may return block-level elements
              // (e.g. TrekDayByDay's "Walk:" line), which are invalid inside <p>.
              <div style={{
                fontSize: '14px',
                lineHeight: 1.6,
                color: 'var(--ink-mid)',
                fontWeight: 300,
                paddingBottom: '16px',
              }}>
                {renderAnswer(item)}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
